/*
 * @Author: your name
 * @LastEditors: 谢树和 shuhe.xie@southgis.com
 * @Date: 2021-07-12 17:20:08
 * @LastEditTime: 2022-10-17 10:57:06
 * @Motto: Your smile is my rainbow
 * @Website: https://www.fairy520.top/
 * @Github: https://github.com/CharlsPrince
 * @FilePath: \maine:\git\xadc\src\utils\axios\jobUnitQuery.api.js
 * @Description: Do not edit
 */
import Http from '@/utils/httpRequest'
const axios = new Http()

export default {
  // 获取测绘单位查询配置
  getQueryConfig() {
    return axios.get('/applet/chdw/public/queryConfig')
  },
  
  // 获取测绘作业单位列表
  getJobUnitQueryList(params) {
    return axios.post('/applet/chdwcx/public/list', params)
  },

  // 获取测绘单位详情信息【根据rid】
  getJobUnitQueryDetail(params) {
    return axios.get('/applet/chdwcx/public/det', params)
  },

  // 详情-获取测绘作业单位资质信息
  getListPageLike(params) {
    return axios.post('/applet/chdwzzxx/public/list', params)
  },

  // 详情-获取测绘作业单位信用信息
  getCreditInfoByRid(params) {
    return axios.post('/applet/chdwxyxx/public/list', params)
  },
  // 详情- 获取测绘作业单位的项目信息
  getProjectInfoByRid(params) {
    return axios.post('/applet/chdwxmxx/public/list', params)
  },
  // 中间页查询
  getJobUnitQuerymiddle() {
    return axios.get('/applet/chdwzjy/public/list')
  }
}
